/**
 * @export
 * @class ReservationInfo
 * 예약현황 링크
 */
export default class ReservationInfo {
  constructor() {
    // 필요 data 유효 확인
    const {
      htDealInfo: {
        categoryInfo: { verticalType },
      },
      htDealContentInfo: {
        contentInfo: { reservationUrl = '' },
      },
    } = TMON.oApp.htStorage.htStaticData;
    if (!verticalType || verticalType !== 'TOUR' || !reservationUrl) return;

    this.welWrapper = $('#_wrapReservationInfo');

    this.setEvent();
    this.render();
  }

  setEvent() {
    // 앱에서 링크 이동 eventListener 등록
    if (TMON.view_mode === 'app') {
      this.welWrapper.on('click', 'a', this.onClickLink);
    }
  }

  clearEvent() {
    if (this.welWrapper && TMON.view_mode === 'app') {
      this.welWrapper.off('click', 'a');
    }
  }

  /**
   * 앱에서 링크 이동 eventListener
   */
  onClickLink(e) {
    e.preventDefault();
    TMON.app.callApp(
      'webview',
      'showNaviWebView',
      '티몬',
      TMON.util.aup($(e.currentTarget).attr('href'), TMON.sAppQuery),
      false,
      false,
      true
    );
  }

  render() {
    const {
      htDealContentInfo: {
        contentInfo: { reservationUrl = '' },
      },
    } = TMON.oApp.htStorage.htStaticData;

    const sHtml = `<h3 class="tit_align_left">예약현황</h3>
            <div class="ct">
                <a href="${reservationUrl}" class="another_view" target="_blank" data-tlarea="MDDIA" data-tlord="7">
                    <p>예약현황 보기</p>
                </a>
            </div>`;

    this.welWrapper.html(sHtml).removeClass('ct_empty');
  }
}
